//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
// import SpeakersConfiguration from '@/configurations/content/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
// import PartnersConfiguration from '@/configurations/content/partners' // @/configurations/content/partners-dark для темной темы

export default {
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'CODERETREAT x T1. Код-ретрит Т1 + Московский клуб программистов',
    description: [
      '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/star.png"  align="left"><b><font>Что такое код-ретрит?</font></b></img>',
     'Код-ретрит представляет собой интенсивное мероприятие, разработанное специально для программистов, желающих улучшить свои навыки. Во время код-ретрита вы сможете погрузиться в мир парного программирования, решать реальные задачи и получать обратную связь от опытных менторов.',
     'Код-ретриты проводятся по всему миру, а их координация осуществляется на сайте <a href="Http://coderetreat.org/">coderetreat.org</a>. Каждый год сообщество устраивает дни ретрита, когда люди собираются по всему миру и осваивают новые практики.',
     '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/cal.png"  align="left"><b><font>Когда и где?</font></b></img>',
     '11 ноября по адресу: Москва, м. Динамо, Ленинградский проспект, 36с41, БЦ Арена (23 этаж). Тайминг ниже. Вход free. На площадке для участников будет организовано питание.',
     '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/study.png"  align="left"><b><font>Что вас ждет на код-ретрите?</font></b></img>',
     'Вас ждет серия практических заданий, где вы сможете улучшить свои технические навыки, научиться эффективно взаимодействовать и применять передовые методы разработки. Благодаря парному программированию вы сможете ускорить процесс разработки, повысить качество кода и достичь лучших результатов.',
     '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/smile.png"  align="left"><b><font>Что брать с собой?</font></b></img>',
     '<ul><li>ноутбук с настроенным софтом (любимая IDE, компиляторы, интерпретаторы, средства сборки)</li><li>заранее изучите вопрос, как пишут и запускают тесты в вашем стеке</li><li>хорошее настроение</li><li>паспорт для пропуска в БЦ</li></ul>',
     '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/all.png"  align="left"><b><font>Как принять участие?</font></b></img>',
     'Зарегистрируйтесь прямо сейчас, чтобы забронировать свое место на код-ретрите. Мы ограничили количество мест, чтобы обеспечить комфортную атмосферу.',
     'На площадке нам будет помогать команда модераторов под управлением SCRUM-мастера Светланы Кривенко.',
     '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/rock.png"  align="left"><b><font>Добро пожаловать на код-ретрит Холдинга Т1 и Московского клуба программистов!</font></b></img>'
    ],
    date: '11 ноября 2023',
    time: '09:30 - 17:00'
  },
  activities: [
    {
      hash: 'UuOZePCj',
      id: 1291
    //  tabName: 'Первый день'
    }
  //  {
  //    hash: 'PXBhAboi',
  //    id: 1106,
  //    tabName: 'Второй день' // название таба, при многозальном мероприятии
  //  }
  ],
  player: {
  // title: 'Дни конференции' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
   // items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/map1.png'), // путь до изображения для блока с картинкой
    items: [
      'Москва, Ленинградский проспект, 36с41, БЦ Арена',
      'Станция метро «Динамо», последний вагон из центра, выход No 2. От метро повернуть налево, дойти до арки, пройти прямо через Петровский парк до магазина «Азбука вкуса», повернуть налево и прямо до БЦ «Арена Парк». Далее - на 23 этаж.',
      'Пожалуйста, возьмите с собой папорт, права или другой документ, удостоверяющий личность.',
      '<a href="https://yandex.ru/maps/org/t1/50117834986/?ll=37.570051%2C55.789947&mode=search&sctx=ZAAAAAgBEAAaKAoSCRA8vr1ryEJAEavoD8085UtAEhIJDhMNUvAUqj8RMdKL2v0qkD8iBgABAgMEBSgKOABAmJIHSAFqAnJ1nQHNzEw9oAEAqAEAvQEh%2BUFlwgEG6vGF2roB6gEA8gEA%2BAEAggIX0KIxIElUINC60L7QvNC%2F0LDQvdC40Y%2BKAgCSAgCaAgxkZXNrdG9wLW1hcHM%3D&sll=37.570051%2C55.789947&source=serp_navig&sspn=0.025470%2C0.007895&text=%D0%A21%20IT%20%D0%BA%D0%BE%D0%BC%D0%BF%D0%B0%D0%BD%D0%B8%D1%8F&z=16">Карта проезда</a>'
    ]
  },
 // partners: {
 //   //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
 //   items: PartnersConfiguration,
 //   title: 'Вакансии' // заголовок блока "Партнёры
// },

  info: {
    title: 'Вакансии', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<a href="https://t1.ru/career/"><img style="margin-right:30px" src="assets/partners/QR3.svg" width="130" height="130" align="left"></img></a>',
     'Если ты ищешь <a name="my_position"></a>карьеру, которая будет развивать твой потенциал, и хочешь работать с лучшими профессионалами в своей области, то  приглашаем тебя посетить наш карьерный сайт.',
     '<a href="http://bit.ly/t1career">Здесь ты найдешь</a> информацию о вакансиях, программе стажировок, а также о возможностях для профессионального и личностного роста в Холдинге Т1!'
    ]
  },

  footer: {
    copyright: 'Холдинг Т1 ©'
  }
}
